"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnHuUsd = exports.EnHuEur = exports.EnHuHuf = exports.HuHuUsd = exports.HuHuEur = exports.HuHuHuf = void 0;
class HuHuHuf {
    constructor() {
        this.locale = "hu-hu";
        this.dateFormat = {
            short: "yyyy.MM.dd.",
            medium: "yyyy. MMMM d.",
            long: "yyyy. MMMM d., dddd",
        };
        this.currencyFormat = {
            code: "HUF",
            symbol: "Ft",
            decimalSeparator: ",",
            groupSeparator: " ",
            positivePattern: "n C",
            negativePattern: "-n C"
        };
    }
}
exports.HuHuHuf = HuHuHuf;
class HuHuEur {
    constructor() {
        this.locale = "hu-hu";
        this.dateFormat = {
            short: "yyyy.MM.dd.",
            medium: "yyyy. MMMM d.",
            long: "yyyy. MMMM d., dddd",
        };
        this.currencyFormat = {
            code: "EUR",
            symbol: "€",
            decimalSeparator: ",",
            groupSeparator: " ",
            positivePattern: "n C",
            negativePattern: "-n C"
        };
    }
}
exports.HuHuEur = HuHuEur;
class HuHuUsd {
    constructor() {
        this.locale = "hu-hu";
        this.dateFormat = {
            short: "yyyy.MM.dd.",
            medium: "yyyy. MMMM d.",
            long: "yyyy. MMMM d., dddd",
        };
        this.currencyFormat = {
            code: "USD",
            symbol: "$",
            decimalSeparator: ",",
            groupSeparator: " ",
            positivePattern: "n C",
            negativePattern: "-n C"
        };
    }
}
exports.HuHuUsd = HuHuUsd;
class EnHuHuf {
    constructor() {
        this.locale = "en-hu";
        this.dateFormat = {
            short: "dd.MM.yyyy",
            medium: "MMMM dd, yyyy",
            long: "dddd, MMMM dd, yyyy",
        };
        this.currencyFormat = {
            code: "HUF",
            symbol: "HUF",
            decimalSeparator: ",",
            groupSeparator: " ",
            positivePattern: "n C",
            negativePattern: "-n C"
        };
    }
}
exports.EnHuHuf = EnHuHuf;
class EnHuEur {
    constructor() {
        this.locale = "en-hu";
        this.dateFormat = {
            short: "dd.MM.yyyy",
            medium: "MMMM dd, yyyy",
            long: "dddd, MMMM dd, yyyy",
        };
        this.currencyFormat = {
            code: "EUR",
            symbol: "€",
            decimalSeparator: ",",
            groupSeparator: " ",
            positivePattern: "n C",
            negativePattern: "-n C"
        };
    }
}
exports.EnHuEur = EnHuEur;
class EnHuUsd {
    constructor() {
        this.locale = "en-hu";
        this.dateFormat = {
            short: "dd.MM.yyyy",
            medium: "MMMM dd, yyyy",
            long: "dddd, MMMM dd, yyyy",
        };
        this.currencyFormat = {
            code: "USD",
            symbol: "$",
            decimalSeparator: ",",
            groupSeparator: " ",
            positivePattern: "n C",
            negativePattern: "-n C"
        };
    }
}
exports.EnHuUsd = EnHuUsd;
